// Note: As of July 20, 2016, Widevine only supports SW_SECURE_CRYPTO on
// audio files. See https://www.widevine.com/product_news.html
//
// Note that we only check for `audio/mp4` for audio capabilities, even though
// our video files have different audio encodings. This is because all our audio
// tracks are only encoded in this format. We therefore require it regardless,
// and we want to fail as soon as possible.
export const EMEConfigs = [
    {
        label: 'video-sw-decode',
        initDataTypes: ['cenc'],
        audioCapabilities: [
            {
                contentType: 'audio/webm; codecs="opus"',
                robustness: 'SW_SECURE_CRYPTO',
            },
            {
                contentType: 'audio/mp4; codecs="mp4a.40.2"',
                robustness: 'SW_SECURE_CRYPTO',
            },
        ],
        videoCapabilities: [
            {
                contentType: 'video/webm; codecs="vp9"',
                robustness: 'SW_SECURE_DECODE',
            },
            {
                contentType: 'video/webm; codecs="vp8"',
                robustness: 'SW_SECURE_DECODE',
            },
            {
                contentType: 'video/mp4; codecs="avc1.4d401f"',
                robustness: 'SW_SECURE_DECODE',
            },
            {
                contentType: 'video/mp2t; codecs="avc1.4d401f"',
                robustness: 'SW_SECURE_DECODE',
            },
        ],
        distinctiveIdentifier: 'optional',
        persistentState: 'optional',
        sessionTypes: ['temporary'],
    },
    {
        label: 'video-sw-crypto',
        initDataTypes: ['cenc'],
        audioCapabilities: [
            {
                contentType: 'audio/webm; codecs="opus"',
                robustness: 'SW_SECURE_CRYPTO',
            },
            {
                contentType: 'audio/mp4; codecs="mp4a.40.2"',
                robustness: 'SW_SECURE_CRYPTO',
            },
        ],
        videoCapabilities: [
            {
                contentType: 'video/webm; codecs="vp9"',
                robustness: 'SW_SECURE_CRYPTO',
            },
            {
                contentType: 'video/webm; codecs="vp8"',
                robustness: 'SW_SECURE_CRYPTO',
            },
            {
                contentType: 'video/mp4; codecs="avc1.4d401f"',
                robustness: 'SW_SECURE_CRYPTO',
            },
            {
                contentType: 'video/mp2t; codecs="avc1.4d401f"',
                robustness: 'SW_SECURE_CRYPTO',
            },
        ],
        distinctiveIdentifier: 'optional',
        persistentState: 'optional',
        sessionTypes: ['temporary'],
    },
    {
        label: 'video-no-robustness',
        initDataTypes: ['cenc'],
        audioCapabilities: [
            {
                contentType: 'audio/webm; codecs="opus"',
                robustness: '',
            },
            {
                contentType: 'audio/mp4; codecs="mp4a.40.2"',
                robustness: '',
            },
        ],
        videoCapabilities: [
            {
                contentType: 'video/webm; codecs="vp9"',
                robustness: '',
            },
            {
                contentType: 'video/webm; codecs="vp8"',
                robustness: '',
            },
            {
                contentType: 'video/mp4; codecs="avc1.4d401f"',
                robustness: '',
            },
            {
                contentType: 'video/mp2t; codecs="avc1.4d401f"',
                robustness: '',
            },
        ],
        distinctiveIdentifier: 'optional',
        persistentState: 'optional',
        sessionTypes: ['temporary'],
    },
    {
        label: 'audio-sw-crypto',
        initDataTypes: ['cenc'],
        audioCapabilities: [
            {
                contentType: 'audio/mp4; codecs="mp4a.40.2"',
                robustness: 'SW_SECURE_CRYPTO',
            },
        ],
        videoCapabilities: [],
        distinctiveIdentifier: 'optional',
        persistentState: 'optional',
        sessionTypes: ['temporary'],
    },
    {
        label: 'audio-no-robustness',
        initDataTypes: ['cenc'],
        audioCapabilities: [
            {
                contentType: 'audio/mp4; codecs="mp4a.40.2"',
                robustness: '',
            },
        ],
        videoCapabilities: [],
        distinctiveIdentifier: 'optional',
        persistentState: 'optional',
        sessionTypes: ['temporary'],
    },
];
//# sourceMappingURL=configs.js.map